import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IconModule } from '../icon/icon.module';
import { OverlayModule } from '@angular/cdk/overlay';

import { CalendarDayPicker } from './calendar-day-picker.component';
import { CalendarDayOverlay } from './calendar-day-overlay.component';

@NgModule({
  declarations: [
    CalendarDayPicker,
    CalendarDayOverlay,
  ],
  exports: [
    CalendarDayPicker,
    CalendarDayOverlay
  ],
  imports: [
    CommonModule,
    OverlayModule,
    FormsModule,
    IconModule,
  ],
  entryComponents: [
    CalendarDayOverlay,
  ],
})
class CalendarDayPickerModule { }

export {
  CalendarDayPickerModule,
  CalendarDayPicker,
  CalendarDayOverlay,
};
